import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';



const GET_POST = gql`
query MyQuery($firmCode: String!) {
    tbl_firm_main_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_main_name_n
    firm_main_type_n
    int_ID
    create_user
    update_user
    created_at
    updated_at
  }
  tbl_firm_sub_coop(where: {firm_main_code_n: {_eq: $firmCode}}) {
    own_firm_main_code
    own_firm_sub_code
    own_firm_sub_type
    firm_main_code_n
    firm_sub_code_n
    firm_sub_name_n
    firm_sub_type_n
    int_ID
    
  }
  tbl_user_detail(where: {firm_main_code: {_eq: $firmCode}}) {
    firm_main_code
    firm_sub_code
    user_name
    name
    last_name
    user_type
    dpr_main_code
    dpr_sub_code
    user_lang
    data_lang
    create_user
    update_user
    created_at
    updated_at
  }
}
`;

const UPDATE_FIRM = gql`
mutation UpdateFirm(
 
  $firmCode: String!
  $firmName: String!
  ) {
  update_tbl_firm_main_coop(
    where: { firm_main_code_n: { _eq: $firmCode } }
    _set: { firm_main_name_n: $firmName }
  ) {
    affected_rows
  }
}
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_FIRM = gql`
  mutation InsertFirm(
    $firmMainCode: String!
    $firmCode: String!
    $firmName: String!
    $firmType: String!
    $ownFirmCode: String!
    $ownFirmSubCode: String!
    $ownFirmSubType: String!
    
  ) {
    insert_tbl_firm_sub_coop(
      objects: {
        firm_main_code_n: $firmMainCode,
        firm_sub_code_n: $firmCode,
        firm_sub_name_n: $firmName,
        firm_sub_type_n: $firmType,
        own_firm_main_code: $ownFirmCode,
        own_firm_sub_code: $ownFirmSubCode,
        own_firm_sub_type: $ownFirmSubType,
        
        
      }
    ) {
      affected_rows
    }
  }
`;

const GET_TEMP_RECORDS = gql`
  query GetTempRecords($tempType: String, $lang: String, $coop1: String) {
    tbl_temp(where: { temp_type: { _eq: $tempType }, opt_1: { _eq: $lang } , opt_3: { _eq: $coop1 } }) {
      temp_code
      temp_name
      temp_group
      temp_type
      opt_1
      opt_2
      opt_3
    }
  }
`;



const GET_TEMP_RECORDS2 = gql`
  query GetTempRecords($tempType2: String, $lang2: String, $coop2: String) {
    tbl_temp(where: { temp_type: { _eq: $tempType2 }, opt_1: { _eq: $lang2 }, opt_3: { _eq: $coop2 } }) {
      temp_code
      temp_name
      temp_group
      temp_type
      opt_1
      opt_2
      opt_3
    }
  }
`;

const INSERT_TEMP_RECORDS_MUTATION = gql`
  mutation InsertTempRecordsIntoDprMain($records: [tbl_dpr_main_coop_insert_input!]!) {
    insert_tbl_dpr_main_coop(objects: $records) {
      affected_rows
    }
  }
`;

const INSERT_TEMP_RECORDS_MUTATION2 = gql`
  mutation InsertTempRecordsIntoDprSub($records: [tbl_dpr_sub_coop_insert_input!]!) {
    insert_tbl_dpr_sub_coop(objects: $records) {
      affected_rows
    }
  }
`;




const OperatorCreateSubCoop = () => {
   
  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertFirm] = useMutation(INSERT_FIRM);


  const [tempType, setTempType] = useState('OMDPR');
  const [lang, setLang] = useState("en");
  const [tempType2, setTempType2] = useState('OSDPR');
  const [lang2, setLang2] = useState("en");
  const [coop1, setCoop1] = useState('OCOOP');
  const [coop2, setCoop2] = useState("OCOOP");

  const { loading: tempLoading, error: tempError, data: tempData } = useQuery(GET_TEMP_RECORDS, {
    variables: { tempType, lang, coop1 },
  });

  const { loading: tempLoading2, error: tempError2, data: tempData2 } = useQuery(GET_TEMP_RECORDS2, {
    variables: { tempType2, lang2, coop2 },
  });

  

  
  const {varCode, setVarCode} = useContext(ThemeContext);
  const {theme, setTheme} = useContext(ThemeContext);
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmMainCode, setFirmMainCode] = useState(varCode);
 const [firmCode, setFirmCode] = useState();
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("OPR");
  const [place, setPlace] = useState("");
  const [fmActive, setFmActive] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

 
  const [verim, setVerim] = useState('T0002');
 
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;

 
  const intl = useIntl();
  const currentLocale = lang; 
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  const int_id = messages[currentLocale].int_id;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const time_zone = messages[currentLocale].time_zone;
  const create_sub_firm = messages[currentLocale].create_sub_firm;
  const firm_insert_successfully = messages[currentLocale].firm_insert_successfully;

 



  /* insert main dpr */

  const [insertTempRecords] = useMutation(INSERT_TEMP_RECORDS_MUTATION);
  const [insertTempRecords2] = useMutation(INSERT_TEMP_RECORDS_MUTATION2);

 

  const handleInsertTempRecords = async () => {
    try {    
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = tempData.tbl_temp.map((record) => ({
        own_firm_main_code: ownFirmCode,
        own_firm_sub_code: ownFirmSubCode,
        own_firm_sub_type: ownFirmSubType,
        firm_main_code_n: firmMainCode,
        firm_sub_code_n: firmCode,
        dpr_main_code_n: record.temp_code,
        dpr_main_name_n: record.temp_name,
        dpr_main_grp_code_n: record.temp_group,
      }));
  
      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertTempRecords({
        variables: { records: recordsToInsert },
      });
  
      const affectedRows = insertData.insert_tbl_dpr_main_coop.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_main.`);
      handleInsertTempRecords2();
   
      
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_main:', error);
    }
    
  };
  
  const  handleInsertTempRecords2 = async () => {
    console.log("calıstı");
    console.log("temptype :" ,tempType);  
    console.log(tempData2.tbl_temp);
    tempData.tbl_temp.forEach((record) => {
      console.log(record);
    });
     
    try {    
      
      
      // tbl_temp tablosundan çekilen veriler döngü 
      const recordsToInsert = tempData2.tbl_temp.map((record) => ({
        own_firm_code: ownFirmCode,
        own_firm_sub_code: ownFirmSubCode,
        own_firm_sub_type: ownFirmSubType,
        firm_main_code_n: firmMainCode,
        firm_sub_code_n: firmCode,
        firm_sub_type_n: firmType,
     
        dpr_main_code_n: record.opt_2,
        dpr_sub_code_n: record.temp_code,
        dpr_sub_name_n: record.temp_name,
        dpr_sub_type_n: record.temp_type,
        dpr_sub_grp_code_n: record.temp_group,
      }));

      // insertTempRecords mutasyon data insert tbl_dpr_main 
      const { data: insertData } = await insertTempRecords2({
        variables: { records: recordsToInsert },
      });

      const affectedRows = insertData.insert_tbl_dpr_sub_coop.affected_rows;
      console.log(`Inserted ${affectedRows} row(s) into tbl_dpr_sub.`);
      console.log(tempData2.tbl_temp);
      
    } catch (error) {
      console.error('Error inserting into tbl_dpr_sub:', error);
      console.log("temptype :" ,tempType);  
    }
  };
  

  /* ınsert main dpr*/


  const handleUpdate = () => {
   
    
    updateFirm({
      variables: {
       
        firmCode: firmCode,
        firmName: firmName,
        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setFirmCode(updatedIdSeq.toString());  
     
      console.log(firmCode);
      
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (firmCode !== "000") {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [firmCode, setFirmCode]);

  const handleinser = () => {
    InsertFirm({
      variables: {
        firmMainCode: firmMainCode,
        firmCode: firmCode,
        firmName: firmName,
        firmType: firmType,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        ownFirmSubType: ownFirmSubType,
    
           
      },
    })
      .then(() => {
        window.alert(firm_insert_successfully);
        handleInsertTempRecords();
      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };



  return (

    <div className="container p-2 mx-auto sm:p-4 ">
      <div className="card  ">
    
      <div className=" p-2 ">
          <div className="pt-1 -my-14 -ml-14 -mr-14 font-thin -mb-5"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_code}</label>
    <InputText className="w-full" 
    id="username" value={firmCode}
    onChange={(e) => setFirmCode(e.target.value)}
    />
  </div>

  <div className="w-2/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{firm_name}</label>
    <InputText className="w-full" 
    id="firmname" value={firmName} 
    onChange={(e) => setFirmName(e.target.value)} />
  </div>
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>
  </div>

  
  <div className="flex gap-3 my-5">
    
  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{firm_type}</label>
    <InputText className="w-full" 
    id="firmtype" 
    name="firmtype"
    value={firmType}
    onChange={(e) => setFirmType(e.target.value)}
    readOnly/>
  </div>

  

  <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="place">{placerec}</label>
    <InputText className="w-full" 
    id="place" 
    name="place"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{time_zone}</label>
    <InputText className="w-full" 
    id="timezone" 
    name="timezone"
    value={place} 
    onChange={(e) => setPlace(e.target.value)} />
  </div>

  <div className=" flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  
      </div>
      <div className="mt-0 ">
        <Button label={create_sub_firm} aria-label="Update" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-900 text-white font-semibold  rounded-md"
          onClick={handleUpdateIdSeq}  
        />
        </div>

</p>
         </Fieldset>
        </div> 

        </div>          
      

    
   </div>
  
  
     
    </div>

    
    
    
 
 
);
};

export default OperatorCreateSubCoop;
